import { Component, Inject } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { UpdateExpedienteNotaRequest } from '@models/expedienteNota/updateExpedienteNotaRequest.model';
import { ExpedienteNotaService } from '@services/expedienteNota/expedienteNota.service';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { DialogExpedienteNotaCreateComponent } from '../dialog-expediente-nota-create/dialog-expediente-nota-create.component';
import { Editor, NgxEditorModule } from 'ngx-editor';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AppRolesDirective } from '@directives/appRoles/app-roles.directive';
import { FormExpedientePartesComponent } from '@views/expedientes/form-expediente-partes/form-expediente-partes.component';
import { ListRegistroContableComponent } from '@views/registros-contable/list-registro-contable/list-registro-contable.component';
import { ButtonNewComponent } from 'src/app/component/button-new/button-new.component';
import { GeneralCalendarComponent } from '@component/general-calendar/general-calendar-list/general-calendar.component';
import { GoBackAndTitleComponent } from 'src/app/component/go-back-and-title/go-back-and-title.component';
import { ListExpedienteNotaComponent } from '../list-expediente-nota/list-expediente-nota.component';
import { ButtonSaveComponent } from 'src/app/component/button-save/button-save.component';
import { ButtonCloseDialogComponent } from 'src/app/component/button-close-dialog/button-close-dialog.component';
import { AccionesDialog } from '@models/base/identificadores.model';
import { ButtonCancelDialogComponent } from "../../../component/button-cancel-dialog/button-cancel-dialog.component";

@Component({
  standalone: true,
    imports: [AppRolesDirective, MatFormFieldModule, MatInputModule, ReactiveFormsModule, MatCardModule, MatTabsModule, MatIconModule, MatButtonModule, MatDividerModule, NgxSpinnerModule, MatTableModule, MatSliderModule, MatSlideToggleModule, MatMenuModule, MatDialogModule, MatDatepickerModule, MatExpansionModule, MatRadioModule, MatSelectModule, ButtonNewComponent, ButtonNewComponent, MatFormFieldModule, MatInputModule, ReactiveFormsModule, MatCardModule, MatIconModule, MatButtonModule, CommonModule, FormsModule, MatSortModule, NgxSpinnerModule, FormsModule, ReactiveFormsModule, CommonModule, ButtonNewComponent, MatTooltipModule, MatPaginatorModule, MatRippleModule, GoBackAndTitleComponent, GeneralCalendarComponent, ListRegistroContableComponent, FormExpedientePartesComponent, ListExpedienteNotaComponent, NgxEditorModule, ButtonSaveComponent, ButtonCloseDialogComponent, ButtonCancelDialogComponent,ButtonCancelDialogComponent],
  selector: 'app-dialog-expediente-nota-update',
  templateUrl: './dialog-expediente-nota-update.component.html',
  styleUrls: ['./dialog-expediente-nota-update.component.css']
})
export class DialogExpedienteNotaUpdateComponent {

  formBuilder: FormBuilder = new FormBuilder;
  form: any;
  editor!: Editor

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<DialogExpedienteNotaCreateComponent>,
    private expedienteNotaService: ExpedienteNotaService,
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService,

  ) {

    this.editor = new Editor();
  this.form = this.formBuilder.group({
    Descripcion: ['',Validators.compose([Validators.required])],

  });
  }
  ngOnInit() {
    this.getNgModuleById()
  }

  onSubmit() {
    if (this.form.invalid) {
      return;
    }
    const updateExpedienteNotaRequest: UpdateExpedienteNotaRequest = new UpdateExpedienteNotaRequest
    updateExpedienteNotaRequest.descripcion = this.form.controls['Descripcion'].value == "" ? null : this.form.controls['Descripcion'].value;
    updateExpedienteNotaRequest.idExpediente = this.data.idExpediente
    this.spinner.show("spNota")
    this.expedienteNotaService.update(updateExpedienteNotaRequest)
      .subscribe(
        data => {
          this.spinner.hide("spNota")
          this.snackBar.showSuccess("Se modifico el registro correctamente.", "Exito");
          this.dialogRef.close({accion: AccionesDialog.Modificar, data:data});
        },
        error => {
          this.spinner.hide("spNota")
          this.snackBar.showError(error, "Error");
          this.dialogRef.close({accion: AccionesDialog.Cancelar, data:null});
        })
  }

  getNgModuleById() {
    this.spinner.show("spNota")
    this.expedienteNotaService.getById(this.data.id)
      .subscribe(
        data => {
          this.spinner.hide("spNota")
          this.snackBar.showSuccess("Se modifico el registro correctamente.", "");
        },
        error => {
          this.spinner.hide("spNota")
          this.snackBar.showError(error, "Error");
        })
  }
}
